<template>
    <div class="cursor-pointer px-2 py-1 rounded shadow text-center text-xxs font-semibold flex items-center ml-3"
        :class="selected === value ? 'bg-indigo-100 xl:bg-indigo-200 text-indigo-900' : 'bg-indigo-500 hover:bg-indigo-200 text-indigo-100 hover:text-indigo-900'"
        @click="$emit('click', value)"
    >
        {{ label }}

        <span class="w-6 flex items-center justify-center">
            <i v-show="selected === value" class="material-icons text-xs pl-1 -mr-1">
                south
            </i>
        </span>
    </div>
</template>

<script>
export default {
    props: {
        label: {},
        value: {},
        selected: {},
    },
}
</script>
